<template>
    <div>
        <iframe class='map-preview' :src="store.manual_map_preview" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        <div class='store-details-container'>
            <div class='store-name'>{{store.name}}</div>
            <div><span class='sub-heading'>Distance:</span> {{store.formatted_distance}} miles</div>
            <div>{{store.address}}</div>
            <div><span class='sub-heading'>Contact:</span> {{store.phone}}</div>
        </div>
        <Button text='Select' theme='light' @click='selectedStore'/>
    </div>
</template>

<script>
import Button from '@/ecom/components/buttons/Button.vue';

export default {
    components: {Button},
    props: ['store'],
    emits: ['selectedStoreListener'],
    methods:{
        selectedStore(){
            this.$emit('selectedStoreListener', this.store);
        }
    }
}
</script>

<style lang="scss" scoped>

.store-details-container{
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 10px;
    max-width: 270px;
    height: 150px;
}

.store-name{
    font-weight: 600;
}

.sub-heading{
    color: var(--medium-cool-grey)
}

.map-preview{
    width: 270px;
    height: 320px;
    border: 0;
}
</style>